<template>
  <v-card flat class="pt-0">
    <v-card-title class="">
      <v-icon class="mr-2">mdi-map-marker</v-icon>
      <h2 class="title-h2 primary--text">Shipping Address</h2>
    </v-card-title>
    <v-form ref="form" lazy-validation>
      <v-row class="pb-0">
        <v-col class="pr-1" cols="7">
          <v-text-field
            v-model="form.name"
            class="mb-3"
            outlined
            dense
            hide-details
            label="Address Name"
          />
        </v-col>
        <v-col>
          <v-checkbox
            class="my-1"
            label="Primary Shipping Address"
            hide-details
            v-model="form.primary"
          />
        </v-col>
      </v-row>
      <v-text-field
        v-model="form.address_1"
        required
        class="mb-3"
        :rules="rules"
        outlined
        dense
        hide-details
        label="Address 1 *"
      />
      <v-text-field
        v-model="form.address_2"
        class="mb-3"
        outlined
        dense
        hide-details
        label="Address 2"
      />

      <v-row class="pb-0">
        <v-col class="pr-1" cols="7">
          <v-text-field
            v-model="form.suburb"
            required
            class="mb-3"
            :rules="rules"
            outlined
            dense
            hide-details
            label="City / Suburb*"
          />
        </v-col>
        <v-col class="pl-1">
          <v-text-field
            v-model="form.postal_code"
            :rules="rules"
            required
            class="mb-3"
            outlined
            dense
            hide-details
            label="Post Code *"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pr-1 pt-0" cols="7">
          <v-autocomplete
            outlined
            dense
            label="Country *"
            v-model="form.country"
            :rules="rules"
            :items="country"
            :item-text="country.text"
            :item-value="country.value"
          />
        </v-col>
        <v-col class="pl-1 pt-0">
          <v-text-field
            v-model="form.state"
            class="mb-3"
            outlined
            dense
            hide-details
            label="State"
          />
        </v-col>
      </v-row>
    </v-form>
    <v-card-actions>
      <v-spacer />
      <v-btn class="btn-error" @click="$emit('cancel')">Cancel</v-btn>
      <v-btn class="btn-primary" @click="confirm">Save</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import client from "@/lib/ApiClient"

export default {
  name: "ShippingAddress",

  props: ["value"],

  data() {
    return {
      countryList: [],
      rules: [(v) => !!v || "Required"]
    }
  },

  async mounted() {
    this.countryList = await client.gateway.tenants.fetchCountries()
  },

  computed: {
    form() {
      return this.value
    },

    country() {
      return this.countryList.map((item) => {
        return {
          text: item.name,
          value: item.code
        }
      })
    }
  },

  methods: {
    validateForm() {
      return this.$refs.form.validate()
    },

    confirm() {
      if (!this.validateForm()) return
      this.$emit("confirm")
    }
  }
}
</script>
